export function products (state, products) {
	state.products = [ ...products ];
}
